var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrapper",style:({ backgroundColor: _vm.wrapperColor, opacity: _vm.wrapperOpacity })},[_c('div',{staticClass:"dot-icon",style:({ backgroundColor: _vm.backgroundColor })})])}
var staticRenderFns = []

export { render, staticRenderFns }